import { FC } from 'react'

export const IconOutOfGaugeRear: FC<{ zoom?: number; size?: number }> = ({ zoom, size }) => {
  return (
    <svg
      width={size ?? '32'}
      height={size ?? '32'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: `scale(${(zoom ?? 100) / 100})` }}
    >
      <path
        d='M5.72426 5H14.7C14.8657 5 15 5.13431 15 5.3L15 14.2757C15 14.543 14.6769 14.6769 14.4879 14.4879L11.8788 11.8788C11.7616 11.7616 11.5717 11.7616 11.4545 11.8788L6.8788 16.4545C6.76164 16.5717 6.57169 16.5717 6.45453 16.4545L3.54547 13.5455C3.42831 13.4283 3.42831 13.2384 3.54547 13.1212L8.1212 8.54546C8.23836 8.42831 8.23836 8.23836 8.1212 8.1212L5.51213 5.51213C5.32314 5.32314 5.45699 5 5.72426 5Z'
        fill='#212B36'
      />
    </svg>
  )
}

export default IconOutOfGaugeRear
